import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Text from '../../../../shared/_TBComponents/Text';

// _TBComponents/Modal's `title` prop renders an empty <IconRound> circle when
// no icon is given, so these modals pass `hideTitle` and use this heading instead.

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
`;

const CloseX = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  color: #9E9E9E;
  padding: 0 2px;
  flex-shrink: 0;
  &:hover { color: #444444; }
  &:focus-visible { outline: 2px solid #1787FB; outline-offset: 2px; }
`;

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

const ModalHeading = ({ title, subtitle, onClose }) => (
  <Header>
    <TitleGroup>
      <Text styledTextProps={{ fontSize: '20px', fontWeight: 800, color: '#333333' }}>
        {title}
      </Text>
      {subtitle && (
        <Text styledTextProps={{ fontSize: '13.5px', fontWeight: 400, color: '#9E9E9E' }}>
          {subtitle}
        </Text>
      )}
    </TitleGroup>
    {onClose && (
      <CloseX type='button' onClick={onClose} aria-label='Close'>×</CloseX>
    )}
  </Header>
);

ModalHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClose: PropTypes.func,
};

ModalHeading.defaultProps = {
  subtitle: undefined,
  onClose: undefined,
};

export default ModalHeading;
